import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntil } from 'rxjs';
import { AbstractComponent } from 'src/app/shared/components/abstract.component';
import { SnackItem, SnackbarService } from '../../../services/snackbar.service';
import { SnackComponent } from './snack/snack.component';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SnackComponent],
})
export class SnackbarComponent extends AbstractComponent implements OnInit {
  private readonly _snack: SnackbarService = inject(SnackbarService);

  public snackItems: SnackItem[] = [];

  public ngOnInit(): void {
    this._snack.notification$
      .pipe(takeUntil(this._destroyed$))
      .subscribe((item: SnackItem) => {
        this.snackItems.push(item);
      });
  }

  public onClear(item: SnackItem): void {
    this.snackItems = this.snackItems.filter((i: SnackItem) => i !== item);
  }

  public trackSnack(index: number, snack: SnackItem): number {
    return snack.id;
  }
}
